/**
 * useSnowflakeHook - 极简雪花ID生成Hook
 * 默认单机使用，workerId=0, datacenterId=0，epoch=2025-09-25
 */
export function useSnowflakeHook() {
    const workerId = 0n;
    const datacenterId = 0n;
    const sequenceBits = 12n;
    const workerIdBits = 5n;
    const datacenterIdBits = 5n;
    const twepoch = 1758739200000n; // 2025-09-25 00:00:00

    const sequenceMask = (1n << sequenceBits) - 1n;
    const workerIdShift = sequenceBits;
    const datacenterIdShift = sequenceBits + workerIdBits;
    const timestampLeftShift = sequenceBits + workerIdBits + datacenterIdBits;

    let sequence = 0n;
    let lastTimestamp = -1n;

    function _timeGen() {
        return BigInt(Date.now());
    }

    function _tilNextMillis(lastTs) {
        let ts = _timeGen();
        while (ts <= lastTs) {
            ts = _timeGen();
        }
        return ts;
    }

    function generateId() {
        let timestamp = _timeGen();

        if (timestamp < lastTimestamp) {
            const diff = lastTimestamp - timestamp;
            if (diff <= 5n) {
                timestamp = _tilNextMillis(lastTimestamp);
            } else {
                throw new Error(`Clock moved backwards. Refusing to generate id for ${diff}ms`);
            }
        }

        if (timestamp === lastTimestamp) {
            sequence = (sequence + 1n) & sequenceMask;
            if (sequence === 0n) {
                timestamp = _tilNextMillis(lastTimestamp);
            }
        } else {
            sequence = 0n;
        }

        lastTimestamp = timestamp;

        const id = ((timestamp - twepoch) << timestampLeftShift) |
            (datacenterId << datacenterIdShift) |
            (workerId << workerIdShift) |
            sequence;

        return id.toString(); // 返回数字字符串
    }

    return {
        generateId
    };
}
